import { Component } from '@angular/core';

@Component({
  selector: 'app-starter-header-ts',
  standalone: true,
  imports: [],
  templateUrl: './starter-header-th.component.html',
})
export class StarterHeaderTsComponent {}
